import { useEffect, useState } from "react";
// import star from "../../asset/Sales/star.svg";
// import curvedLine from "../../asset/Sales/curvedLne.svg";
import salesCall from "../../asset/Sales/SalesCall.svg"
// function Star({ size = 18, className = "" }) {
//   return (
//     <img src={star} alt="" width={size} height={size} className={className} />
//   );
// }

const STEPS = ["Transcript", "Discovery", "Solution", "Objection"];
const curvedLines = [
  {
    className:
      "absolute left-[17%] sm:left-[18%] md:left-[21%] lg:left-[18%] top-[24%] md:top-[24%] lg:top-[24%] w-[45px] sm:w-[55px] md:w-[60px] lg:w-[70px] sa-line-left",
    transform: "none",
  },

  {
    className:
      "absolute left-[17%] sm:left-[18%] md:left-[21%] lg:left-[18%] top-[46%] md:top-[50%] lg:top-[50%] w-[45px] sm:w-[55px] md:w-[60px] lg:w-[70px] sa-line-left",
    transform: "scaleY(-1)",
  },

  {
    className:
      "absolute right-[17%] sm:right-[18%] md:right-[21%] lg:right-[18%] top-[24%]  md:top-[24%] lg:top-[24%] w-[45px] sm:w-[55px] md:w-[60px] lg:w-[70px] sa-line-right",
    transform: "scaleX(-1)",
  },

  {
    className:
      "absolute right-[17%] sm:right-[18%] md:right-[21%] lg:right-[18%] top-[46%] md:top-[50%] lg:top-[50%] w-[45px] sm:w-[55px] md:w-[60px] lg:w-[70px] sa-line-right",
    transform: "scale(-1,-1)",
  },
];
// ---- timing (seconds) — one full loop ----
const LOOP = 7;

const LEFT_LINE = [0.15, 0.45];

const BOX_ON = [0.55, 0.85, 1.15, 1.45];

const RIGHT_LINE = [1.65, 2.0];

const TICK_IN = [2.05, 2.3];

const FADE = [5.5, 6.0];

const pct = (s) => `${(s / LOOP) * 100}%`;
const stepCardSize = {
  wrapper: `
absolute

left-[30%]
sm:left-[36%]
md:left-[34%]
lg:left-[32%]

top-[21%]
md:top-[19%]
lg:top-[20%]

flex
flex-col

gap-2
sm:gap-3
md:gap-4
lg:gap-5
`,

  card: `
w-[110px]
md:w-[180px]
lg:w-[180px]

h-[26px]
md:h-[34px]
lg:h-[38px]

text-[9px]
md:text-[12px]
lg:text-[14px]
`,
};
const leftCircle = {
  wrapper: `
absolute

left-[5%]
md:left-[9%]
lg:left-[6%]

top-[120px]
md:top-[147px]
lg:top-[180px]
-translate-y-1/2
`,

  outer: `
w-10 h-10
md:w-16 md:h-16
border-[4px]
bg-white
lg:w-17 lg:h-17
`,

  inner: `
w-5 h-5
md:w-12 md:h-12
bg-white
lg:w-14 lg:h-14
`,
};

const rightCircle = {
  wrapper: `
absolute

right-[6%]
sm:right-[4%]
md:right-[10%]
lg:right-[8%]

top-[118px]
sm:top-[135px]
md:top-[147px]
lg:top-[180px]

-translate-y-1/2

z-30
`,

  outer: `
w-8 h-8
sm:w-9 sm:h-9
md:w-10 md:h-10
lg:w-14 lg:h-14
`,
};
export default function AboutSection() {
  const [mounted, setMounted] = useState(false);
  useEffect(() => {
    const t = requestAnimationFrame(() => setMounted(true));
    return () => cancelAnimationFrame(t);
  }, []);

  return (
    <div className="relative w-full overflow-hidden">
      <section
        className="
    relative
    w-full

    px-4
    sm:px-6
    md:px-10
    lg:px-16
    xl:px-20

    py-16
    md:py-20

    overflow-hidden
  "
      >
        {" "}
        {/* yellow ambient glow behind the ENTIRE right side of the section (not just the card) */}
        <div
          className="absolute top-0 bottom-0 right-0 w-1/2 opacity-60 blur-3xl pointer-events-none"
          style={{
            background:
              "radial-gradient(circle at 100% 100%,#FFE29A 0%,#FFEFC7 35%,transparent 12%)",
          }}
        />
        <style>{`
        .sa-fade-l{opacity:0;transform:translateX(-50px);transition:opacity .8s ease,transform .8s ease}
        .sa-fade-r{opacity:0;transform:translateX(80px) scale(.95);transition:opacity .9s ease,transform .9s ease}
        .sa-in{opacity:1!important;transform:translateX(0) scale(1)!important}

        @keyframes sa-agent-pulse{0%,100%{transform:scale(1)}50%{transform:scale(1.08)}}

        @keyframes sa-line{
          0%{opacity:.5}
          ${pct(LEFT_LINE[0])}{opacity:.5}
          ${pct(LEFT_LINE[1])}{opacity:1}
          ${pct(FADE[0])}{opacity:1}
          ${pct(FADE[1])}{opacity:.5}
          100%{opacity:.5}
        }
        @keyframes sa-line-r{
          0%{opacity:.5}
          ${pct(RIGHT_LINE[0])}{opacity:.5}
          ${pct(RIGHT_LINE[1])}{opacity:1}
          ${pct(FADE[0])}{opacity:1}
          ${pct(FADE[1])}{opacity:.5}
          100%{opacity:.5}
        }
        ${STEPS.map(
          (_, i) => `
        @keyframes sa-box-${i}{
          0%{border-color:#F5CFC6;box-shadow:0 4px 10px rgba(0,0,0,0.04);transform:scale(1)}
          ${pct(BOX_ON[i] - 0.05)}{border-color:#F5CFC6;box-shadow:0 4px 10px rgba(0,0,0,0.04);transform:scale(1)}
          ${pct(BOX_ON[i] + 0.25)}{border-color:#EB604A;box-shadow:0 8px 18px rgba(235,96,74,0.18);transform:scale(1.03)}
          ${pct(FADE[0])}{border-color:#EB604A;box-shadow:0 8px 18px rgba(235,96,74,0.18);transform:scale(1.03)}
          ${pct(FADE[1])}{border-color:#F5CFC6;box-shadow:0 4px 10px rgba(0,0,0,0.04);transform:scale(1)}
          100%{border-color:#F5CFC6;box-shadow:0 4px 10px rgba(0,0,0,0.04);transform:scale(1)}
        }
        @keyframes sa-check-${i}{
          0%{opacity:0}
          ${pct(BOX_ON[i] - 0.05)}{opacity:0}
          ${pct(BOX_ON[i] + 0.15)}{opacity:1}
          ${pct(FADE[0])}{opacity:1}
          ${pct(FADE[1])}{opacity:0}
          100%{opacity:0}
        }`,
        ).join("\n")}

    @keyframes sa-tick{
  0%{
    opacity:0;
    transform:scale(.2);
    visibility:hidden;
  }

  ${pct(TICK_IN[0])}{
    opacity:0;
    transform:scale(.2);
    visibility:hidden;
  }

  ${pct(TICK_IN[0]) + 0.1}{
    visibility:visible;
  }

  ${pct(TICK_IN[1])}{
    opacity:1;
    transform:scale(1.15);
    visibility:visible;
  }

  ${pct(TICK_IN[1]) + 0.2}{
    transform:scale(1);
  }

  ${pct(FADE[0])}{
    opacity:1;
    visibility:visible;
  }

  ${pct(FADE[1])}{
    opacity:0;
    transform:scale(.2);
    visibility:hidden;
  }

  100%{
    opacity:0;
    visibility:hidden;
    transform:scale(.2);
  }
}
    @keyframes sa-tick-mark{

  0%{
    stroke-dashoffset:1;
  }

  ${pct(TICK_IN[0])}{
    stroke-dashoffset:1;
  }

  ${pct(TICK_IN[1])}{
    stroke-dashoffset:0;
  }

  ${pct(FADE[0])}{
    stroke-dashoffset:0;
  }

  ${pct(FADE[1])}{
    stroke-dashoffset:1;
  }

  100%{
    stroke-dashoffset:1;
  }
}

.sa-tick-mark{
    stroke-dasharray:1;
    stroke-dashoffset:1;
    animation:sa-tick-mark ${LOOP}s linear infinite;
}
        .sa-agent-ring{animation:sa-agent-pulse 2s ease-in-out infinite}
        .sa-line-left{animation:sa-line ${LOOP}s ease-in-out infinite}
        .sa-line-right{animation:sa-line-r ${LOOP}s ease-in-out infinite}
        ${STEPS.map(
          (
            _,
            i,
          ) => `.sa-box-${i}{animation:sa-box-${i} ${LOOP}s ease-in-out infinite}
        .sa-check-${i}{animation:sa-check-${i} ${LOOP}s ease-in-out infinite}`,
        ).join("\n")}
       @keyframes sa-loader{

  0%{
    opacity:1;
    transform:rotate(0deg);
  }

  ${pct(TICK_IN[0])}{
    opacity:1;
    transform:rotate(720deg);
  }

  ${pct(TICK_IN[1])}{
    opacity:0;
  }

  100%{
    opacity:0;
  }

}

.sa-loader{
    animation:sa-loader ${LOOP}s linear infinite;
    transform-origin:center;
}
        .sa-tick-wrap{
    transform:scale(1);
}
.sa-tick-mark{
    stroke-dasharray:1;
    stroke-dashoffset:1;
    animation:sa-tick-mark ${LOOP}s ease forwards infinite;
}  
  @keyframes aiTitle{

0%{
opacity:0;
transform:translateY(-8px);
}

100%{
opacity:1;
transform:translateY(0);
}

}
@keyframes aiText{

0%{
opacity:0;
}

100%{
opacity:1;
}

}


@keyframes aiSection{

0%{
opacity:0;
transform:translateX(18px);
}

8%{
opacity:1;
transform:translateX(0);
}

88%{
opacity:1;
transform:translateX(0);
}

100%{
opacity:1;
transform:translateX(0);
}

}

.sa-card{
  opacity:0;
  animation:aiSection 12s ease-in-out infinite;
}
.card-1{
  animation-delay:.3s;
}

.card-2{
  animation-delay:.8s;
}

.card-3{
  animation-delay:1.3s;
}

.card-4{
  animation-delay:1.8s;
}
@keyframes aiCardFloat{
  0%,100%{
    transform:translateY(0px);
  }

  50%{
    transform:translateY(-6px);
  }
}

@keyframes aiCardGlow{
  0%,100%{
    box-shadow:
      0 12px 30px rgba(0,0,0,.12);
  }

  50%{
    box-shadow:
      0 18px 40px rgba(232,96,74,.22);
  }
}

.sa-ai-card{
  animation:
    aiCardFloat 4s ease-in-out infinite,
    aiCardGlow 4s ease-in-out infinite;
}
`}</style>
       <div
  className="
    relative
    z-10
    max-w-[1400px]
    mx-auto

    grid
    grid-cols-1
    lg:grid-cols-[40%_60%]

    gap-12
    lg:gap-6

    items-center
  "
>
          {" "}
          <div
            className={`
    sa-fade-l

    flex
    flex-col

    items-center
    text-center

    lg:items-start
    lg:text-left

    ${mounted ? "sa-in" : ""}
  `}
          >
            <div className="inline-flex px-4 py-1 rounded-md bg-[#FFE9E4]">
              <span className="text-[#EB604A] font-semibold text-[12px] md:text-[14px] lg:text-[16px] font-prompt">
                About Us
              </span>
            </div>
            <h2
              className="mt-6 text-[#464342] font-prompt font-semibold text-2xl
md:text-4xl
lg:text-4xl leading-tight font-prompt"
            >
             Your AI Sales 
             <br/>
Assistant for Every 
              <br />
             Customer Conversation
            </h2>
            <p
              className="
mt-6

max-w-[340px]
md:max-w-[550px]
lg:max-w-[500px]

mx-auto
lg:mx-0

text-[12px]
md:text-[15px]
lg:text-[15px]
text-[#0C0200]

font-jakarta
"
            >
           Your best salesperson can't be in every meeting. Sales AI ensures every rep has access to the same expertise, guidance, and confidence in every conversation. Instead of simply recording meetings, Sales AI actively helps your team have better conversations, respond with confidence, and close more deals with a real-time AI overlay visible only to the sales rep.
            </p>
          </div>
          <div
            className={`
sa-fade-r

relative

w-full
max-w-[900px]
xl:max-w-[980px]

mx-auto

h-[260px]
sm:h-[300px]
md:h-[320px]
lg:h-[360px]
xl:h-[380px]

${mounted ? "sa-in" : ""}
`}
          >
            {/* card shell — the yellow glow now sits behind this, not clipped inside it */}
            <div className="absolute inset-0 rounded-[22px] border border-[#F4B9AE] bg-white/40 backdrop-blur-[24px] shadow-[0_25px_60px_rgba(235,96,74,.08)]" />

            {/* {curvedLines.map((line, i) => (
              <img
                key={i}
                src={curvedLine}
                className={line.className}
                style={{ transform: line.transform }}
                alt=""
              />
            ))}
            <div className={leftCircle.wrapper}>
              <div
                className={`sa-agent-ring ${leftCircle.outer}
rounded-full
md:border-[5px]
lg:border-[6px]

border-[#FFD8CF]
bg-white
flex
items-center
justify-center`}
              >
                <div
                  className={`w-14 h-14 rounded-full font-prompt  flex items-center justify-center text-center text-[8px] md:text-[12px] lg:text-[13px] font-semibold text-[#EB604A] leading-[1.2] ${leftCircle.inner}`}
                  style={{ fontFamily: "'Poppins',sans-serif" }}
                >
                  Sales Agent
                </div>
              </div>
              <div className="absolute right-2 -top-3 md:-top-3 lg:-top-3 text-[#EB604A]">
                <Star size={window.innerWidth < 640 ? 13 : 18} />
              </div>
            </div>

            <div className={stepCardSize.wrapper}>
              {STEPS.map((item, i) => (
                <div
                  key={item}
                  className={`
sa-box-${i}

${stepCardSize.card}

relative
rounded-lg
border
bg-white
shadow-md

flex
items-center
justify-center
font-prompt
font-semibold
text-[#4C4C4C]
`}
                >
                  {item}
                  <span
                    className={`sa-check-${i} absolute right-3 w-4 h-4 rounded-full bg-[#EB604A] flex items-center justify-center`}
                  >
                    <Check size={11} className="text-white" strokeWidth={3} />
                  </span>
                </div>
              ))}
            </div>

            <div className={rightCircle.wrapper}>
              <div className="relative">
                <div
                  className={`
        ${rightCircle.outer}
        rounded-full
        bg-[#EB604A]
        border-[6px]
        border-[#FFD7CF]
        flex
        items-center
        justify-center
        overflow-hidden
      `}
                >
                

                  <svg
                    className="absolute inset-0 m-auto sa-loader"
                    width="20"
                    height="20"
                    viewBox="0 0 50 50"
                  >
                    <circle
                      cx="25"
                      cy="25"
                      r="18"
                      fill="none"
                      stroke="white"
                      strokeWidth="5"
                      strokeLinecap="round"
                      strokeDasharray="90"
                      strokeDashoffset="25"
                    />
                  </svg>

           

                  <svg
                    viewBox="0 0 24 24"
                    width="20"
                    height="20"
                    className="absolute"
                  >
                    <path
                      className="sa-tick-mark"
                      d="M5 13l4 4L19 7"
                      fill="none"
                      stroke="white"
                      strokeWidth="3"
                      strokeLinecap="round"
                      strokeLinejoin="round"
                      pathLength="1"
                    />
                  </svg>
                </div>

                <div
                  className="
    absolute
    -right-1
    -top-1

    sm:-right-2
    sm:-top-2

    lg:-right-3
    lg:-top-3
  "
                >
                  <Star size={window.innerWidth < 640 ? 10 : 18} />
                </div>
              </div>
            </div> */}
            <div
  className={`
    sa-fade-r

    relative

    w-full
    max-w-[920px]

    mx-auto

    h-[260px]
    sm:h-[340px]
    md:h-[420px]
   lg:h-[430px]


    ${mounted ? "sa-in" : ""}
  `}
>
  {/* Outer Border */}
  <div className="absolute inset-0 rounded-[16px]  border border-[#F3B6A8] bg-white/60 backdrop-blur-md shadow-[0_25px_70px_rgba(235,96,74,.08)]" />

  {/* Sales Call UI */}
  <img
    src={salesCall}
    alt=""
    className="
      absolute

    left-[8%]
    bottom-[17%]
lg:bottom-[13%]
md:bottom-[16%]

w-[75%]
md:w-[57%]
lg:w-[55%]
      rounded-md

      shadow-xl

      z-10
    "
  />

{/* ================= AI Recommendation Card ================= */}

<div
  className="
  sa-ai-card
absolute

right-[2%]
top-[8%]
md:top-[7%]
lg:top-[35px]
w-[48%]
sm:w-[44%]
lg:w-[46%]

h-[80%]
md:h-[82%]
lg:h-[82%]
rounded-[5px]

bg-white

border
border-[#E8604A29]

shadow-[0_12px_30px_rgba(0,0,0,.12)]

overflow-hidden

z-20
"
>

  {/* Discovery */}
  <div className="sa-card card-1 lg:px-4 lg:py-2 md:px-4 md:py-2 px-2 py-1 border-b border-[#ECECEC]">

    <h4
      className="
font-poppins
font-semibold

text-[#EB604A]
mt-1
text-[9px]
md:text-[11px]
lg:text-[12px]
"
    >
      Discovery Guidance
    </h4>

    <p
      className="
mt-1

font-poppins

text-[#666]

text-[7px]
md:text-[10px]
lg:text-[11px]

leading-[1.6]
"
    >
      Great start!

      You've uncovered their budget.

      <br />

      Ask about their timeline and
      decision process next.
    </p>

  </div>

  {/* Solution */}

  <div className="sa-card card-2 lg:px-4 lg:py-2 md:px-4 md:py-2 px-2 py-1 border-b border-[#ECECEC]">

    <h4
      className="
font-poppins
font-semibold

text-[#EB604A]

text-[9px]
md:text-[11px]
lg:text-[12px]
"
    >
      Solution Recommendation
    </h4>

    <p
      className="
mt-1

font-poppins

text-[#666]

text-[7px]
lg:text-[11px]
md:text-[10px]
leading-[1.6]
"
    >
      Smart Match:

      Enterprise Plan

      <br />

      • AI Automation

      <br />

      • Team Analytics

      <br />

      • Scalable Growth
    </p>

  </div>

  {/* Objection */}

  <div className="sa-card card-3 lg:px-4 lg:py-2 md:px-4 md:py-2 px-2 py-1 border-b border-[#ECECEC]">

    <h4
      className="
font-poppins
font-semibold

text-[#EB604A]

text-[9px]
md:text-[11px]
lg:text-[12px]
"
    >
      Objection Handling
    </h4>

    <p
      className="
mt-1

font-poppins

text-[#666]

text-[7px]
lg:text-[11px]
md:text-[10px]
leading-[1.6]
"
    >
      Suggested Reply

      <br />

      "Most teams recover ROI
      within just a few weeks."
    </p>

  </div>

  {/* Post Call */}

  <div className="sa-card card-4 lg:px-4 lg:py-2 md:px-4 md:py-2 px-2 py-1">

    <h4
      className="
font-poppins
font-semibold

text-[#EB604A]

text-[9px]
md:text-[11px]
lg:text-[12px]
"
    >
      Post-Call Insights
    </h4>

    <p
      className="
mt-1

font-poppins

text-[#666]

text-[7px]
lg:text-[11px]
md:text-[10px]
leading-[1.6]
"
    >
      • High Buying Intent

      <br />

      • Demo Recommended

      <br />

      • Follow-up Tomorrow
    </p>

  </div>

</div>
</div>
          </div>
        </div>
      </section>
    </div>
  );
}
